import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private http: HttpClient) {}

  onLogin(token: any) {
    return this.http.post(`${environment.apiUrl}/v1/login`, { token });
  }
}
